export default {
    getAllProducts: env => {
        return {
            url: `/${env}/products`,
            method: 'GET',
        };
    },
    getProductsDetails: (env, homeId, productType, productIdentifier) => {
        return {
            url: `/${env}/products/:homeId/:productType/:productIdentifier`,
            method: 'GET',
            route_params: {
                homeId,
                productType,
                productIdentifier,
            },
        };
    },
    getProductsByHomeId: (env, homeId) => {
        return {
            url: `/${env}/products/:homeId`,
            method: 'GET',
            route_params: {
                homeId,
            },
        };
    },
    getStatsProducts: (env, homeId) => {
        return {
            url: `/${env}/products/:homeId/stats`,
            method: 'GET',
            route_params: {
                homeId,
            },
        };
    },
    getStatsProductsConsoProd: (env, homeId, fromDate, product_identifier, code) => {
        return {
            url: `/${env}/products/:homeId/:productIdentifier/stats`,
            method: 'GET',
            route_params: {
                homeId,
                productIdentifier: product_identifier,
            },
            get_params: {
                fromDate,
                code,
            },
        };
    },
    getProductsConsoProd: (env, homeId) => {
        return {
            url: `/${env}/products/:homeId/consoProd`,
            method: 'GET',
            route_params: {
                homeId,
            },
        };
    },
    updateProductField: (env, fieldName, homeId, identifier, type, fieldValue, moduleType) => {
        return {
            url: `/${env}/products/:homeId/:type/:identifier/:moduleType/update`,
            method: 'PATCH',
            patch_params: {
                fieldName: fieldName,
                fieldValue: fieldValue,
                productType: type,
                identifier: identifier,
            },
            route_params: {
                homeId,
                type,
                identifier,
                moduleType,
            },
        };
    },
    dissociateProduct: (env, fieldName, homeId, identifier, type, fieldValue, moduleType) => {
        return {
            url: `/${env}/products/:homeId/:type/:identifier/:moduleType/dissociate`,
            method: 'PATCH',
            patch_params: {
                fieldName: fieldName,
                fieldValue: fieldValue,
                productType: type,
                identifier: identifier,
            },
            route_params: {
                homeId,
                type,
                identifier,
                moduleType,
            },
        };
    },
    updateProductModule: (env, homeId, identifier, productType, code, form, type, lineType) => {
        return {
            url: `/${env}/products/:homeId/:productType/:identifier/:type/:lineType/updateProductModule`,
            method: 'PATCH',
            patch_params: {
                code: code,
                homeId: homeId,
                identifier: identifier,
                productType: productType,
                form: form,
            },
            route_params: {
                homeId,
                productType,
                identifier,
                type,
                lineType,
            },
        };
    },
    deleteProduct: (env, homeId, productType, productIdentifier, type) => {
        return {
            url: `/${env}/products/:homeId/:productType/:productIdentifier/:type/deleteProduct`,
            method: 'PATCH',
            route_params: {
                homeId,
                productType,
                productIdentifier,
                type,
            },
        };
    },
};



// WEBPACK FOOTER //
// ./environments/genericEnv/data/Products/api.js